import axios from 'axios';
import Cookies from 'js-cookie';

const token = Cookies.get('lark-customerauth-token');
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        Signature: process.env.REACT_APP_SIGNATURE,
    },
});

export const customerAPI = axios.create({
    baseURL: process.env.REACT_APP_CUSTOMER_API_URL,
    headers: {
        'Content-Type': 'application/json',
        Authorization: token ? `Bearer ${token}` : '',
        Signature: process.env.REACT_APP_SIGNATURE,
    },
});

// New

const API_URL = `${process.env.REACT_APP_API_URL}/customer`;

// List of public routes that don't need authentication
const PUBLIC_ROUTES = [
    '/customer/auth/verify-otp',
    '/customer/auth/login-otp',
    '/customer/auth/login',
];

const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 10000, // 10 seconds
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        // Check if the route is public
        const isPublicRoute = PUBLIC_ROUTES.some(route => config.url?.includes(route));

        if (!isPublicRoute) {
            config.headers.Signature = process.env.REACT_APP_SIGNATURE;
            const token = Cookies.get('lark-customerauth-token');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Handle token expiration
        if (error.response?.data?.details?.unauthorized && !originalRequest._retry) {
            originalRequest._retry = true;
            Cookies.remove('lark-customerauth-token');
            window.location.href = '/login';
          }

        return Promise.reject(error);
    }
);

export default axiosInstance;
